// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3EbsO","title":"FrontImage_title__2e0Kr"};